/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum GuideChannelOptionsOverlayActions {
    WATCH_NOW,
    FAVORITE_CHANNEL_ADD_REMOVE,
    VIEW_GUIDE_WITH_SELECTED_FILTERS,
    CATEOGORIES_FILTER_PILL,
    CHANNELS_FILTER_PILL,
}

export enum OneLineGuideChannelOptionsOverlayActions {
    WATCH_NOW,
    GO_TO_GRID_GUIDE,
    FAVORITE_CHANNEL_ADD_REMOVE,
    VIEW_GUIDE_WITH_SELECTED_FILTERS,
    CATEOGORIES_FILTER_PILL,
    CHANNELS_FILTER_PILL,
}

export enum EmptyGuideChannelOptionsOverlayActions {
    VIEW_GUIDE_WITH_SELECTED_FILTERS,
    CATEOGORIES_FILTER_PILL,
    CHANNELS_FILTER_PILL,
}

export enum EmptyOneLineGuideChannelOptionsOverlayActions {
    GO_TO_GRID_GUIDE,
    VIEW_GUIDE_WITH_SELECTED_FILTERS,
    CATEOGORIES_FILTER_PILL,
    CHANNELS_FILTER_PILL,
}

export enum EmptyFilteredGuideChannelOptionsOverlayActions {
    VIEW_GUIDE_WITH_SELECTED_FILTERS,
    CATEOGORIES_FILTER_PILL,
    CHANNELS_FILTER_PILL,
}

export enum FilteredGuideChannelOptionsOverlayActions {
    WATCH_NOW,
    FAVORITE_CHANNEL_ADD_REMOVE,
    VIEW_GUIDE_WITH_SELECTED_FILTERS,
    CATEOGORIES_FILTER_PILL,
    CHANNELS_FILTER_PILL,
}
